import { GildedCalligraphy } from './GildedCalligraphy';

export default GildedCalligraphy;
